import axios from 'axios';
import config from '../common/config';

export default {
  fetchCategories(token) {
    return axios.get(`${config.config.ROOT_URL}/categories_api`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },

  createCategory(token, categoryData) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(categoryData));
    
    return axios.post(`${config.config.ROOT_URL}/create_category_api`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'
      }
    });
  },

  updateCategory(token, categoryId, categoryData) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(categoryData));
    
    return axios.post(`${config.config.ROOT_URL}/update_category_api/${categoryId}`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'
      }
    });
  },

  deleteCategory(token, categoryId) {
    return axios.delete(`${config.config.ROOT_URL}/delete_category_api/${categoryId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },

  createSubcategory(token, categoryId, subcategoryData) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(subcategoryData));
    
    return axios.post(`${config.config.ROOT_URL}/create_subcategory_api/${categoryId}`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'
      }
    });
  },

  updateSubcategory(token, categoryId, subcategoryId, subcategoryData) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(subcategoryData));
    
    return axios.post(`${config.config.ROOT_URL}/update_subcategory_api/${categoryId}/${subcategoryId}`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'
      }
    });
  },

  deleteSubcategory(token, categoryId, subcategoryId) {
    return axios.delete(`${config.config.ROOT_URL}/delete_subcategory_api/${categoryId}/${subcategoryId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
}; 